import { render, staticRenderFns } from "./OptnEdit.vue?vue&type=template&id=d92d8a30&scoped=true&"
import script from "./OptnEdit.vue?vue&type=script&lang=js&"
export * from "./OptnEdit.vue?vue&type=script&lang=js&"
import style0 from "./OptnEdit.vue?vue&type=style&index=0&id=d92d8a30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d92d8a30",
  null
  
)

export default component.exports